import { BLOCKCHAINS, PROVIDERS } from "../wallets/providers";
import { ChainNativeCurrency } from "./network.interface";
import { TwitterAccSettings } from "./points.interface";
import { DBAffiliate, IGetWhiteList, PaginatedResult } from ".";
import { TradingKeyType } from "@libs/shared/interfaces";

export interface IUserState {
  activeAddress: string;
  activeBalance: string;
  walletCurrency: ChainNativeCurrency,
  mainAddress: string;
  mainChain: BLOCKCHAINS | null;
  userKeys: ITradingKey[];
  userWhiteLists: PaginatedResult<IGetWhiteList>;
  userLockalKey: IStorageTradingKey;
  selectedPair: IPair;
  isKYCVerification: boolean,
  isAffiliate: boolean | null,
  isAffiliatePageEnabled: boolean,
  affiliateData: DBAffiliate,
  minBalance: number;
  userPoints: number;
  userSocials: UserSocials;
  userBalances: balancesCacheT;
};

interface Balance {
  address: string;
  timestamp: Date;
  balance: string;
};
export type balancesCacheT = {[key:string]: Balance};

export interface UserSocials {
  twitter: {
    userName: string;
    twitterId: string;
    name: string;
    permissions: TwitterAccSettings;
  };
  telegram: {
    userName: string;
    telegramId: string;
  };
  discord:  {
    userName: string;
    name: string;
    discordId: string;
  };
  email: string;
}

export interface IUserWallet {
  address: string;
  name: string;
  providerId: string;
}

export interface IPair {
  id: number;
  base_chain_id: number;
  base_currency: string;
  base_decimal: number;
  base_id: string;
  min_order_size: string;
  min_price_increment: string;
  min_size_increment: string;
  is_active: boolean;
  pairId: number,
  pair_key: string;
  pair_name: string;
  price_chain_id: number;
  price_currency: string;
  price_decimal: number;
  price_id: string;
  restrictedCountries: string[];
  inuseWithPartners: number[];
  pairSettings: IPairSettings;
  delisting_date?: Date;
  new_orders_disabled?: boolean;
  current_price: string;
  h: string;
  l: string;
  l_p: string;
  price_24: string;
  total_24: string;
  volume_24: string;
  change_24: number;
}

export interface IPairSettings {
  audioLink?: string;
  mftTitle?: string;
  baseCoinIconLink?: string;
  baseCoinMarketLink?: string;
  priceCoinIconLink?: string;
  priceCoinMarketLink?: string;
  makerFee: number;
  takerFee: number;
  preSaleMode?: {
    sellerAddress: string;
  }
}

export enum PairSettingsIds {
  MFT_AUDIO_LINK = 'mft.audioLink',
  MFT_TITLE = 'mft.title',
  VIEW_BASE_COIN_ICON_LINK = 'view.baseCoinIconLink',
  VIEW_BASE_COIN_MARKET_LINK = 'view.baseCoinMarketLink',
  VIEW_PRICE_COIN_ICON_LINK = 'view.priceCoinIconLink',
  VIEW_PRICE_COIN_MARKET_LINK = 'view.priceCoinMarketLink',
  MAKER_FEE = 'makerFee',
  TAKER_FEE = 'takerFee',
  MODE_PRE_SALE = 'mode.preSale',
}

export interface IPairDto {
  id: number;
  base_chain_id: number;
  base_currency: string;
  base_decimal: number;
  base_id: string;
  min_order_size: string;
  min_price_increment: string;
  min_size_increment: string;
  is_active: boolean;
  pairId: number,
  pair_key: string;
  pair_name: string;
  price_chain_id: number;
  price_currency: string;
  price_decimal: number;
  price_id: string;
  restrictedCountries: string[];
  inuseWithPartners: number[];
  pairSettings: {
    [PairSettingsIds.MFT_AUDIO_LINK]?: string;
    [PairSettingsIds.MFT_TITLE]?: string;
    [PairSettingsIds.VIEW_BASE_COIN_ICON_LINK]?: string;
    [PairSettingsIds.VIEW_BASE_COIN_MARKET_LINK]?: string;
    [PairSettingsIds.VIEW_PRICE_COIN_ICON_LINK]?: string;
    [PairSettingsIds.VIEW_PRICE_COIN_MARKET_LINK]?: string;
    [PairSettingsIds.MAKER_FEE]?: string;
    [PairSettingsIds.TAKER_FEE]?: string;
    [PairSettingsIds.MODE_PRE_SALE]?: {
      sellerAddress: string;
    }
  };
  delisting_date?: Date;
  new_orders_disabled?: boolean;
  current_price?: string;
  h?: string;
  l?: string;
  l_p?: string;
  price_24?: string;
  total_24?: string;
  volume_24?: string;
  change_24?: string;
}

export interface FavoritePair {
  address: string;
  pair_key: string;
}

export interface MainWallet {
  address: string;
  provider: PROVIDERS;
  token: string;
  chain: BLOCKCHAINS;
}

export interface IStorageTradingKey {
  address: string,
  mnemonic?: string,
  expiredAt: number
}

export interface ITradingKey {
  address: string,
  createdAt: Date,
  expiredAt: Date,
  orders: number,
  device: string,
  type?: TradingKeyType
}

export interface ISDKTradingKey {
  tkAddress: string,
  expiredDate?: number,
  loginAddress: string,
  loginChainId: number,
  device?: string,
  type?: TradingKeyType
}
